'use client';

import React, { useMemo, useEffect, useState } from 'react';

import { TasticProps } from '../types';
import {
  AlgoliaRecommendationProvider,
  BoughtTogetherItems,
} from 'components/commercetools-ui/organisms/product/product-recommendations';
import { LineItem } from 'shared/types/cart';
import { useCart } from 'frontastic/hooks';
import { useBadgeLoader } from 'helpers/utils/badgeLoader';
import { P2Badge } from 'components/commercetools-ui/organisms/product/product-list-algolia/types';
import useLocale from 'helpers/hooks/useLocale';

const AlgoliaBoughtTogetherProductTastic = ({ data }: TasticProps<any>) => {
  const { locale } = useLocale();
  const { data: cart } = useCart();
  const [variantCode, setVariantCode] = useState<string | null>(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      setVariantCode(params.get('variantCode'));
    }
  }, []);
  const variantCodes = useMemo(() => {
    if (variantCode) return [variantCode];

    const codes = cart?.lineItems?.map((lineItem: LineItem) => lineItem?.variant?.attributes?.variantCode);
    return codes?.filter(Boolean) || [];
  }, [variantCode, cart?.lineItems?.length]);
  const p1BadgeData = data?.data?.dataSource?.p1BadgeData;
  const p2BadgeData = data?.data?.dataSource?.p2BadgeData;
  const p1Badges = useBadgeLoader(p1BadgeData?.productListingContent);
  const p2Badges = p2BadgeData?.productListingContent as P2Badge[];
  const queryParameters = data?.data?.dataSource?.searchQuery?.[locale?.replace('-', '_')];
  if (!data?.isEnableBoughtTogether || variantCodes.length === 0) return null;

  return (
    <AlgoliaRecommendationProvider>
      <div>
        <BoughtTogetherItems
          objectIDs={variantCodes}
          title={data?.boughtTogetherTitle}
          p1BadgeData={p1Badges}
          p2BadgeData={p2Badges}
          queryParameters={queryParameters}
        />
      </div>
    </AlgoliaRecommendationProvider>
  );
};

export default AlgoliaBoughtTogetherProductTastic;
